export default {
  "open_platform": "乐福开放平台",
  "faster_cheaper": "更快、更省，轻松开发，快速拥有",
  "what_we_can_do": "我们能做什么",
  "custom_smart_scale": "乐福智能秤定制",
  "build_health_ecosystem": "以智能秤为载体，定制您专属的智能硬件、健康管理App、健康管理平台。一站式打造您的健康管理生态圈。",
  "wechat_mini_program_integration": "微信小程序接入",
  "low_cost_health_mini_program": "低成本打造健康管理小程序。为您提供小程序 OEM 定制、ODM 深度定制以及小程序插件自行开发多种定制模式。",
  "view_docs": "查看文档",
  "app_integration": "App接入",
  "ios_android_sdk": "提供iOS和Android平台SDK，帮助开发者简化开发流程，实现蓝牙协议解析和身体数据计算功能。",
  "massive_food_data": "海量食物数据",
  "easily_access_nutritional_info": "轻松获取食物的营养成分、热量、成分等信息。我们的服务基于权威的食品数据库，覆盖百万种食物。",
  "why_choose_us": "为什么选我们",
  "independent_research": "自主研发",
  "professional_team": "拥有上百人的专业研发团队。我司自主研发并拥有30多项新型实用专利，70多项产品外观专利，20多项软件著作权，并且每年新增专利数量位于行业前茅。经过不断的努力，我司于2016年荣获深圳高新技术企业。从项目设计开发，到成品最终定型，都会由我司强大的研发设计团队层层严格把控。",
  "design_innovation": "设计创新",
  "professional_design_team": "公司拥有专业的设计团队，并与外部专业设计公司保持紧密合作，同时积极赞助多项工业设计创意大赛。我们会提供给每位客户专属设计的ID，定稿后全平台保持唯一性，保障每位客户的产品外观都是独一无二的。",
  "comprehensive_quality_control": "全面品控",
  "market_leader_quality": "作为生产制造企业，品质为市场第一竞争力，公司在2015年导入ISO9001：2015质量体系，在2017年导入ISO13485医疗管理体系，2018年拿到了CFDA生产许可证，公司的品质水平仍在不断提升。在严格要求自身的同时，对供应商也制定了高标准考核管理，从产品源头控制品质。公司品质标准位于全行业顶尖水平。",
  "software_customization": "软件定制",
  "professional_stable_service": "无论是小程序还是APP，我们都能提供专业，安全，稳定的服务。公司拥有本行业最大的软件开发团队，并且成功上线案例达到数百个。各个岗位均有行业资深工程师把控，团队目前成员50余人，并处于高速发展中。",
  "smart_manufacturing": "智能制造",
  "logistics_automation": "乐福的智能制造生产线实现从毛坯上线、加工、质量控制和成品下线全过程的物流输送与自动化生产监控，提高了品控和柔性交付的能力，能更有效地满足不同客户的需求。",
  "dedicated_service": "用心服务",
  "pre_sales": "售前：帮助您了解电子秤市场的行情，加强双方的了解，让您选到满意的产品。",
  "in_sales": "售中：安排产品知识培训；生产前开订单评审会议，保证订单顺利交货，确保产品质量。",
  "after_sales": "售后：全天候在线解答您的任何困难或者疑问。拥有完整的售后服务流程与管理体系。",
  "our_partners": "我们的合作伙伴",
  "learn_more": "立即了解",
  "login_register": "登录/注册",
  "personal_info": "个人信息",
  "logout": "退出登录",
  "language": "语言",
  "contact_email": "联系邮箱",
  "product_center": "产品中心",
  "weight_scale": "体重秤",
  "body_fat_scale": "体脂秤",
  "kitchen_scale": "厨房秤",
  "2in1_nutrition_scale": "2in1营养体脂秤",
  "business_cooperation": "商务合作",
  "cooperation_process": "合作流程",
  "core_advantages": "核心优势",
  "customer_cases": "客户案例",
  "about_us": "关于我们",
  "lefufu_intro": "乐福简介",
  "lefufu_culture": "乐福文化",
  "talent_recruitment": "人才招募",
  "homepage": "首页",
  "document_center": "文档中心",
  "compare_data": "对比数据",
  "password_login": "密码登录",
  "code_login": "验证码登录",
  "enter_password": "请输入密码",
  "enter_email_or_phone": "请输入邮箱账号、手机号",
  "get_verification_code": "获取验证码",
  "resend": "重新获取",
  "enter_verification_code": "请输入验证码",
  "new_user_register": "新用户使用短信登录自动注册和乐福账号",
  "agree_terms_conditions": "我已阅读并同意",
  "terms_privacy_policy": "服务条款、隐私政策",
  "go_to_register": "去注册",
  "login": "登录",
  "age_required": "年龄不能为空",
  "enter_valid_number": "请输入数字值",
  "must_be_18_or_above": "必须年满18岁",
  "enter_username": "请输入用戶名",
  "enter_valid_phone": "请输入正确的手机号",
  "username_restrictions": "用户名只能包含字母、数字和下划线，长度在3到16个字符",
  "enter_valid_email": "请输入正确的邮箱地址",
  "phone_email_required": "手机号与邮箱不能为空",
  "enter_valid_phone_email": "请输入正确的手机号或邮箱地址",
  "enter_valid_email_email": "请输入正确的邮箱地址或邮箱地址",
  "enter_phone": "请输入手机号",
  "enter_valid_phone_or_email": "请输入有效的手机号码或邮箱",
  "accept_terms_privacy": "需要勾选服务条款、隐私政策",
  "login_success": "登录成功",
  "account_registration": "账号注册",
  "phone_registration": "手机号注册",
  "account": "账号",
  "enter_account": "请输入账号",
  "password": "密码",
  "confirm_password": "确认密码",
  "email": "邮箱号",
  "verification_code": "验证码",
  "phone_number": "手机号",
  "already_have_account": "已有账户？",
  "direct_login": "直接登录",
  "register": "注册",
  "username_restrictions_2": "用户名只能包含字母、数字和下划线，且必须包含一个字母，长度在3到16个字符",
  "password_requirements": "密码长度需要为6-20个数字英文字符",
  "enter_confirm_password": "请输入确认密码",
  "passwords_do_not_match": "两次输入密码不一致",
  "enter_email": "请输入邮箱",
  "basic_information": "基本信息",
  "enter": "请输入",
  "nickname": "昵称",
  "email_2": "邮箱",
  "once_filled_no_changes": "一旦填写将不可修改，请谨慎填写",
  "phone": "电话",
  "registration_date": "注册日期",
  "company_address": "公司地址",
  "position_in_company": "公司职位",
  "select": "请选择",
  "you_dont_have_appkey": "您还没有appKey",
  "copy": "复制",
  "view_my_appkey": "查看我的AppKey",
  "enter_nickname": "请输入昵称",
  "length_between_2_20": "长度在2到20个字符",
  "enter_registration_date": "请输入注册日期",
  "enter_company_name": "请填写公司名称",
  "enter_company_address": "请填写公司地址",
  "select_position": "请选择职位",
  "male": "男",
  "female": "女",
  "secret": "保密",
  "boss": "老板",
  "operations": "运营",
  "development": "开发",
  "product": "产品",
  "other": "其他",
  "copy_success": "复制成功！",
  "complete_user_company_info": "请先完善用户及公司信息",
  "download_my_config": "获取配置信息",
  "download": "下载",
  "registration_process_document": "注册流程文档",
  "note": "注：如不提供账号可以授权我方账号为开发者",
  "third_party_data_service": "第三方数据服务",
  "operating_document": "操作文档",
  "note2": "注：如不提供相关信息则无法开放此功能",
  "information_related": "信息相关",
  "sender_email": "发件邮箱",
  "default_use": "默认使用",
  "send_password_verification_code_email": "发送密码验证码邮件",
  "sender_email_password": "发件邮箱密码",
  "customer_service_email": "客服邮箱",
  "company_name": "公司名称",
  "language_support": "语言支持",
  "please_select": "请选择",
  "privacy_policy": "隐私政策",
  "user_agreement": "用户协议",
  "company_abbreviation": "公司简称",
  "Joyful_Commerce": "乐福商务",
  "Joyful_Commerce_contact": "乐福商务联系方式",
  "submit": "提交",
  "cancel": "取消",
  "prompt": "提示",
  "need_to_acquire_first": "需要先获取",
  "confirm": "确定",
  "age_cannot_be_blank": "年龄不能为空",
  "please_enter_numeric_value": "请输入数字值",
  "please_enter_apple_id": "请输入苹果账号",
  "please_enter_correct_apple_id": "请输入正确的苹果账号",
  "please_enter_google_id": "请输入谷歌账号",
  "please_enter_correct_google_id": "请输入正确的谷歌账号",
  "cannot_be_blank": "不能为空",
  "language_selection_required": "需要选择语言",
  "incorrect": "不正确",
  "format_error": "格式错误",
  "Simplified_Chinese": "中文简体",
  "Chinese_Taiwan": "中国台湾",
  "Arabic": "阿拉伯语",
  "Czech": "捷克语",
  "German": "德语",
  "English": "英语",
  "Spanish": "西班牙语",
  "French": "法语",
  "Hungarian": "匈牙利语",
  "Italian": "意大利语",
  "Japanese": "日语",
  "Korean": "朝鲜语",
  "Dutch": "荷兰语",
  "Polish": "波兰语",
  "Portuguese": "葡萄牙语",
  "Russian": "俄语",
  "Vietnamese": "越南语",
  "Thai": "泰语",
  "Indonesian": "印尼语",
  "Turkish": "土耳其语",
  "Danish": "丹麦语",
  "avatar_image_must_be_JPG": "上传头像图片只能是 JPG 格式!",
  "avatar_image_size_limit_2MB": "上传头像图片大小不能超过 2MB!",
  "default_use_email": "默认使用uniqueLife@healthscale8.com发送密码验证码邮件",
  "developer_information": "开发者信息",
  "custom_data": "定制资料",
  "contact_info_required": "联系方式不能为空",
  "app_key": "我的AppKey",
  "my_device": "我的设备",
  "add_device": "添加设备",
  "device_name": "蓝牙名称(deviceName)",
  "advLength": "广播数据长度(advLength)",
  "sign": "sign",
  "please_fill_in_the_required_fields": "请填写所有必填项",
  "mini_program_access": "小程序接入",
  "android_access": "Android接入",
  "cloud_computing_library": "云端计算库",
  "ios_access": "IOS接入",
  "software_service": "软件服务",
  "enter_phone_or_email": "请输入手机或邮箱",
  "device_setting": "设备配置",
  "wait_for": "敬请期待",
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh_CN.js